import React from "react";
import { ControlLabel, FormGroup, FormControl } from "react-bootstrap";

function FieldGroup({ id, label, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
    </FormGroup>
  );
}

export { FieldGroup };
